import { Controller, useForm } from 'react-hook-form';
import React, { useEffect, useRef, useState } from 'react';
import { onForgotPassword, onLogin, onRegister, onResetRegisterStates } from '../../store/features/auth/AuthAction';
import { useAppDispatch, useAppSelector } from '../../hooks/utils/ReduxUtil';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { classNames } from 'primereact/utils';
import { useNavigate } from 'react-router-dom';

export const ForgotPasswordForm = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [showMessage, setShowMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const { forgotPasswordEmailSent, forgotPasswordError, forgotPasswordLoading } = useAppSelector((state) => state.auth);

    const toast = useRef(null);

    const defaultValues = {
        email: ''
    };

    const {
        control,
        formState: { errors },
        handleSubmit,
        watch,
        reset
    } = useForm({ defaultValues });

    const onSubmit = (data) => {
        dispatch(
            onForgotPassword({
                email: data.email,
            })
        );
        reset();
    };

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const showSuccess = () => {
        forgotPasswordEmailSent === true && toast.current.show({ severity: 'success', summary: 'Success', detail: 'Email Sent Succesfully. Please Check Your Email', life: 3000 });
    };

    const showError = () => {
        forgotPasswordError !== undefined && toast.current.show({ severity: 'error', summary: 'Error', detail: forgotPasswordError, life: 5000 });
    };

    useEffect(() => {
        if (forgotPasswordEmailSent === true) {
            showSuccess();
        }

        if (forgotPasswordError) {
            showError();
        }

        return () => {
            dispatch(onResetRegisterStates());
        };
    }, [forgotPasswordError, forgotPasswordEmailSent]);

    return (
        <div className="surface-card p-4 shadow-2 border-round w-full">
            <Toast ref={toast} />
            <div className="text-center mb-5">
                <img src="assets/demo/images/blocks/logos/hyper.png" alt="hyper" height="50" className="mb-3" />
                <div className="text-900 text-3xl font-medium mb-3">We'll send you a code to your email address</div>
                <span className="text-600 font-medium line-height-3">it's easy and quick?</span>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
                

                

                <Controller
                    name="email"
                    control={control}
                    rules={{ required: 'Email is required.', pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: 'Invalid email address. E.g. example@email.com' } }}
                    render={({ field, fieldState }) => (
                        <>
                            <label htmlFor={field.name} className={classNames({ 'p-error': errors.email })}></label>
                            <span className="p-float-label">
                                <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                <label htmlFor={field.name}> Email*</label>
                            </span>
                            {getFormErrorMessage(field.name)}
                        </>
                    )}
                />
                <Button type="submit" label="Reset Password" icon="pi pi-user" className="w-full" loading={forgotPasswordLoading} />
            </form>
        </div>
    );
};

export default ForgotPasswordForm;
